import React from 'react'
import TagsPage from 'features/tags/TagsPage'
import { _ } from 'utils'
import { programTagCategoriesQuery, programTagsQuery } from '../graphql/query'
import {
    createProgramTag,
    deleteProgramCategory,
    deleteProgramTag,
    updateProgramCategoryOrder, updateProgramCategory, updateProgramTag,
    updateProgramTagOrder, createProgramCategory
} from '../graphql/mutation'

const ProgramTags = () => (
    <TagsPage
        description={_('show.manage_tags.description')}
        tagKey="programTags"
        categoryKey="programTagCategories"
        tagsQuery={programTagsQuery}
        categoriesQuery={programTagCategoriesQuery}
        updateTagOrder={updateProgramTagOrder}
        updateCategoryOrder={updateProgramCategoryOrder}
        deleteCategory={deleteProgramCategory}
        deleteTag={deleteProgramTag}
        updateTag={updateProgramTag}
        createTag={createProgramTag}
        createCategory={createProgramCategory}
        updateCategory={updateProgramCategory}
    />
)

export default ProgramTags
